<template>
    <div>
        <b-carousel :autoplay="false" indicator-custom :indicator-inside="false" :overlay="gallery">

            <b-carousel-item v-for="(item, i) in images" :key="i" class="has-text-centered">
                <a @click="switchGallery(true)" >
                    <img class="main-img" :src="item.image" alt="producto-imagen-detalle">
                </a>
            </b-carousel-item>
            
            <span v-if="gallery" @click="switchGallery(false)" class="modal-close is-large"/>
            
            <template slot="indicators" slot-scope="props">
                <figure  :draggable="true" class="has-text-centered">
                    <img class="indicator" :draggable="false" :src="getImgUrl(props.i)" :title="props.i" alt="indicador">
                </figure>
            </template>
        
        </b-carousel>
    </div>
</template>

<script>
export default {
    props:{
        images:{
            type:Array,
            default:[]
        }
    },
    data(){
        return{
            gallery:false
        }
    },
    methods:{
        switchGallery(value) {
            this.gallery = value
            if (value) {
                return document.documentElement.classList.add('is-clipped')
            } else {
                return document.documentElement.classList.remove('is-clipped')
            }
        },
        getImgUrl(index){
            return this.images[index].image
        }
    }
}
</script>

<style lang="scss" scoped>
.main-img{
    max-height: 400px;
}
.indicator{
    max-height:90px;
}
</style>